import { DistrictDto } from '@families-link/shared';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { useAppSelector } from '../../../store';

export interface SurveyFiltersState {
	districts: DistrictDto[];
	duration: {
		start: string | null;
		end: string | null;
	};
}

export const initialSurveyFiltersState: SurveyFiltersState = {
	districts: [],
	duration: {
		start: null,
		end: null,
	},
};

export const initialState = {
	districts: [],
	duration: {
		start: null,
		end: null,
	},
};

export const surveyFiltersSlice = createSlice({
	name: 'surveyFilters',
	initialState: initialSurveyFiltersState,
	reducers: {
		setDistricts: (state: SurveyFiltersState, action: PayloadAction<DistrictDto[]>) => {
			state.districts = action.payload;
		},
		setDuration: (state: SurveyFiltersState, action: PayloadAction<{ start: string | null; end: string | null }>) => {
			state.duration = action.payload;
		},
		clearSurveyFilters: (state: SurveyFiltersState) => {
			state.districts = [];
			state.duration = { start: null, end: null };
		},
	},
});

export const { setDistricts, setDuration, clearSurveyFilters } = surveyFiltersSlice.actions;

export const useSurveyFiltersSelector = () => useAppSelector((state) => state.surveyFilters);
